/**
 * 主题类型
 * @type {'default'}
 * @version 1.0.0
 */
export type ThemeType = 'default';